<template>
  <div>System control center</div>
</template>

<script>
export default {
  name: "ControlCenter",
  data() {
    return {};
  },
  created() {
    console.log("center control");
  },
  methods: {}
};
</script>

<style></style>
